import {
  Component,
  OnInit,
  OnDestroy,
  ViewEncapsulation,
  ViewChild,
  ElementRef,
  ChangeDetectorRef,
} from "@angular/core";
import { NgForm } from "@angular/forms";

import * as Papa from 'papaparse';

import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { FlatpickrOptions } from "ng2-flatpickr";

import { CoreSidebarService } from "@core/components/core-sidebar/core-sidebar.service";
import { HttpClient } from "@angular/common/http";
import { environment } from "../../../../environments/environment";
import { UserService } from "../../../../app/auth/service";
import { CustomerService } from "../../../../services/customer.service";

import { first } from "rxjs/operators";
import { Router } from '@angular/router';

import * as snippet from "../../../../app/main/components/tabs/tabs.snippetcode";
import { AuthenticationService } from "../../../../app/auth/service";
import { ToastrService } from "ngx-toastr";

import { ProductService } from "../../../../services/product.service";
import { TemplateService } from "../../../../services/template.service";

import { NgbNavChangeEvent } from "@ng-bootstrap/ng-bootstrap";
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import Swal from "sweetalert2";
import {
  NgbDateStruct,
  NgbCalendar,
  NgbDate,
  NgbDateParserFormatter,
  NgbTimeStruct,
} from "@ng-bootstrap/ng-bootstrap";

import { AccountSettingsService } from "../../../../app/main/pages/account-settings/account-settings.service";
import { ActivatedRoute } from "@angular/router";
import { SharedLocationService } from "../../../../services/shared-location.service";
import { PromoCodeService } from "../../../../services/promocode.service";
import { PricingService } from "../pricing/pricing.service";
import { FileUploader } from "ng2-file-upload";

@Component({
  selector: "app-account-settings",
  templateUrl: "./account-settings.component.html",
  styleUrls: ["./account-settings.component.scss"],
  encapsulation: ViewEncapsulation.None,
})


export class AccountSettingsComponent implements OnInit, OnDestroy {
  // public
  public _snippetCodeJustified = snippet.snippetCodeJustified;
  @ViewChild("updateMyUserForm") updateMyUserForm: NgForm;
  @ViewChild("updateCompanyForm") updateCompanyForm: NgForm;

  @ViewChild("fileInput") fileInput!: ElementRef;

  public hasAnotherDropZoneOver: boolean = false;
  public hasBaseDropZoneOver: boolean = false;
  public selectedFile: File | null = null;
  public fileError;
  public uploadProgress: number = 0;
  public isUploading: boolean = false;
  public uploader: FileUploader = new FileUploader({
    queueLimit: 1,
    url: `${environment.apiUrl}/member/import`,
    isHTML5: true,
    allowedMimeType: ["text/csv", "csv", "vcf"], // Restrict uploads
    // authToken: `Bearer `,
    removeAfterUpload: true, // Clear the queue after upload
    autoUpload: false, // Manually trigger uploads
    maxFileSize: 5 * 1024 * 1024, // Maximum file size allowed in bytes
    method: 'POST',
  itemAlias: 'file',  // Ensure Xano expects 'file' as the field name
  // headers : [
  //   { name: 'Authorization', value: `Bearer ` },
  // ]
  });
  public jsonData: any[] = [];
  public errors: string[] = [];


  public data: any;
  public subscriptions: any;
  public anually = false;
  public contentHeader: object;
  public customer: any;
  public locations: any;
  public promoCodes: any;
  public birthDateOptions: FlatpickrOptions = {
    altInput: true,
  };
  public passwordTextTypeOld = false;
  public passwordTextTypeNew = false;
  public passwordTextTypeRetype = false;
  public plans;
  public alertClose = true;
  public alert = { message: "Error!", type: "danger" };

  public statement: any[];

  public usersList: any = [];
  public loading = false;
  public loadingButton = false;
  public today = new Date().toISOString().slice(0, 10);
  public activeLocations ;

  public paymentPeriod = 'monthly';

  public currentProduct: any = {
    id: null,
    created_at: null,
    location_id: [],
    title: "",
    description: "",
    setupFee: 0,
    startDate: this.today,
    endDate: null,
    servicesProductsDiscounts: {},
    currency: "AUD",
    minPeriod: 12,
    ageFrom: 8,
    ageTo: 65,
    image: "https://i.imgur.com/JvWDeib.jpg",
    status: "inactive",
    pricing: {
      annually: 0,
      monthly: 0,
      weekly: 0,
      fortnightly: 0,
    },
    treatment: [
      {
        title: "Dental Exams",
        annualQuantity: 2,
        score: 100,
        waitingPeriod: 6,
        specificTermsConditions: "No terms",
        procedures: [
          {
            id: 1,
            name: "Comprehensive oral examination",
          },
          {
            id: 2,
            name: "Periodic oral examination",
          },
        ],
      },
    ],
    generalTerms: [
      {
        title: "General",
        content: "",
      },
    ],
  };
  public currentUser: any = { avatar: { url: "" } };
  public currentCoupon: any =
    {
      "name": "",
      "code": "",
      "startDate": this.today,
      "endDate": null,
      "status": null,
      "plan_id": [],
      "settings": {
          "setup_amount": 0,
          "setup_percentage": 0,
          "membership_amount": 0,
          "membership_percentage": 0
      },
      "report": {
          "visualization_counter": 0,
          "activation_counter": 0
      }
  };

  public currentLocation: any = {
    id: null,
    userId: [],
    locationName: "",
    locationAddress: "",
    locationZipCode: "",
    locationPhone: "",
    locationLogo: "",
    locationEmail: "",
    locationWebsite: "",
    locationDocId: "",
    locationDocType: "ABN",
    locationTimeZone: "",
    locationCurrency: "AUD",
    locationStatus: "inactive",
    settings: {
      "member_referral": {
          "isActive": false,
          "creditAmount": 0,
          "membership_amount": 0,
          "membership_percentage": 0,
          "setup_amount": 0,
          "setup_percentage": 0
      },
      "dependent_discount": {
          "isActive": false,
          "goal": 0,
          "membership_amount": 0,
          "membership_percentage": 0,
          "setup_amount": 0,
          "setup_percentage": 0
      }
  }

  };

  public currentTemplate: any = {
      "id": null,
      "created_at": null,
      "location_id": [],
      "title": "",
      "description": "",
      "settings": {
        "limits": {
          "amount": {
            "max": 100000,
            "min": 10
          },
          "monthsLimit": 60,
          "onlyMembers": false
        },
        "editable": {
          "amount": true,
          "deposit": true,
          "adminFee": true,
          "setupFee": true,
          "start_at": true,
          "instalmentTimes": true
        },
              "frequency": {
        "weekly": true,
        "fortnightly": true,
        "monthly": true,
      }
      },
      "content": {
        "amount": null,
        "deposit": null,
        "adminFee": null,
        "setupFee": null,
        "start_at": null,
        "depositCash": true,
        "adminFeeCash": true,
        "setupFeeCash": true,
        "instalmentTimes": null,
        "paymentFrequency": "monthly"
      },
      "status": "active"
    };

  public selectedModal;

  public isModelOpened: boolean = false;


  public myUser: any = {};

  public isAdmin: boolean;

  // Products
  public gridViewRef = true;
  public products;
  public templates;
  public templatesModelList: any[];
  public membershipModelList: any[];
  public page = 1;
  public pageSize = 6;
  public searchTemplate = "";
  public searchMembership = "";
  public selectedGroup;
  public obj_groups;

  public rows: any;
  public active;

  // private
  private _unsubscribeAll: Subject<any>;

  /**
   * Constructor
   *
   * @param {UserService} _userService
   * @param {_customersService} _customersService
   * @param {AccountSettingsService} _accountSettingsService
   * @param {CoreSidebarService} _coreSidebarService
   * @param {ToastrService} _toastrService
   * @param {SharedLocationService} _sharedLocationService
   * @param {PricingService} _pricingService
   */
  constructor(
    private _accountSettingsService: AccountSettingsService,
    private _coreSidebarService: CoreSidebarService,
    private _httpClient: HttpClient,
    private _userService: UserService,
    private _customersService: CustomerService,
    private _authenticationService: AuthenticationService,
    private _toastrService: ToastrService,
    private _route: ActivatedRoute,
    private _productService: ProductService,
    private _templateService: TemplateService,
    private calendar: NgbCalendar,
    private _sharedLocationService: SharedLocationService,
    private _promoCodeService: PromoCodeService,
    private modalService: NgbModal,
    public formatter: NgbDateParserFormatter,
    private _pricingService: PricingService,
    private _router: Router,
    private _cdr: ChangeDetectorRef
  ) {
    this._unsubscribeAll = new Subject();
    this.isAdmin = this._authenticationService.isAdmin;
  }

  // Public Methods
  // -----------------------------------------------------------------------------------------------------
  onNavChange(changeEvent: NgbNavChangeEvent) {
    // if (changeEvent.nextId === 3) {
    // 	changeEvent.preventDefault();
    // }
  }

  /**
   * Toggle Sidebar
   *
   * @param name
   */
  toggleSidebarProd(name): void {
    this._coreSidebarService.getSidebarRegistry(name).toggleOpen();
  }

  /**
   * Update to List View
   */
  listView() {
    this.gridViewRef = false;
  }

  /**
   * Update to Grid View
   */
  gridView() {
    this.gridViewRef = true;
  }

  /**
   * Toggle Password Text Type Old
   */
  togglePasswordTextTypeOld() {
    this.passwordTextTypeOld = !this.passwordTextTypeOld;
  }

  /**
   * Toggle Password Text Type New
   */
  togglePasswordTextTypeNew() {
    this.passwordTextTypeNew = !this.passwordTextTypeNew;
  }

  /**
   * Toggle Password Text Type Retype
   */
  togglePasswordTextTypeRetype() {
    this.passwordTextTypeRetype = !this.passwordTextTypeRetype;
  }

  /**
   * Toggle the sidebar
   *
   * @param name
   */
  toggleSidebar(name, index): void {    
    switch (name) {
      case "location-sidebar":
        this.selectLocation(index);
        break;

      case "edit-user-sidebar":
        this.selectUser(index);
        break;

      case "new-user-sidebar":
        this.selectUser(index);
        break;

      case "template-sidebar":
        this.selectTemplate(index);
        break;

      case "coupon-sidebar":
        this.selectCoupon(index);
        break;
    }

    this._coreSidebarService.getSidebarRegistry(name).toggleOpen();
  }

  openDiscountSetting(modalName){
    var myUser = JSON.parse(localStorage.getItem('currentUser') || '{}');;
    const index = this.locations.findIndex((object) => {
      return object.id === myUser.sessionLocation;
    });

    if (index === -1) {
      console.error('Session location not found in locations array.');
    } else {
      this.selectLocation(index)
      this.modalService.open(modalName, {
        centered: true,
        size: 'lg'
      });  
      }
    
  }

  switchPeriod(isAnually: boolean, frequency: string) {
    this.anually = isAnually;
    this.paymentPeriod = frequency;
    // this.subscriptions.forEach(element => {
    //   if (element.priceDetails[1] != "Forever"){
    //     element.priceDetails[1] = "/month";
    //   }
    // });
  };

  openInvoice(invoiceId: string, typeName: string): void {   
    this._router.navigate(['/apps/invoice/preview/' + invoiceId],{
      queryParams: { type: typeName }
    });
  };

  upgradeRequest(index){
    var selected = this.subscriptions[index];    
  
    this.loadingButton = true;

    if(selected.price.monthly.perMonth == null){
      this._customersService
      .changeSubscription(selected.id, this.paymentPeriod)
      .then((result: any) => {
        
        switch (result.status) {
          case "contacted":
            Swal.fire({
              icon: 'success',
              title: 'Request Submitted!',
              html: `
              <p>${result.message}</p>
              `,
              confirmButtonText: 'OK'
            }).then((result:any)=>{
              
            });
            break;

          case "failed":
            Swal.fire({
              title: "Error",
              text: "This request has not been sent.",
              html:
                '<div><p>'+ result.message +'<p/></div>',
              icon: "error",
              customClass: {
                confirmButton: "btn btn-secondary",
              },
            });
            break;
  
            default:
              break;
        }
      this.loadingButton = false;
      });

    
    }else{
      if(selected.price.monthly.perMonth > 0){
        this._customersService
        .getStatement()
        .then((result: any) => {
  
          if (result.paymentMethod.length > 0) {
            result.paymentMethod.forEach(element => {
              
              if(element.primary_method == true){
                Swal.fire({
                  title: "PROCEED TO CHECKOUT",
                  text: "Use your registered payment method to complete the transaction?",
    
                  html: `
                      <p>Use your registered payment method to complete the transaction?</p>
                      <p><b>Payment Method:</b> ${element.type}</p>
                      <p><b>Last Four Digits:</b> ${element.method_details.last4} </p>`,
    
                  confirmButtonText: "Use Current Payment Method",
                  cancelButtonText: "Add New Payment Method",
                  showCancelButton: true,
    
                  customClass: { 
                    confirmButton: "btn btn-success",
                    cancelButton: "btn btn-primary ml-1",
            
                   },
    
                  }).then((data) => {                
                    if (data.isConfirmed == true) {
                      this._customersService
                      .changeSubscription(selected.id, this.paymentPeriod)
                      .then((result: any) => {
                        
                        switch (result.status) {
                          case "succeeded":
                            this.getSubscriptionList();
                            Swal.fire({
                              icon: 'success',
                              title: 'Subscription activated',
                              html: `
                                <p>${result.message}</p>
                                <p><b>Invoice:</b>                          
                                  ${result.invoice_id}
                                </p>
                                <p><b>Paid now:</b> $${(result.amount.value - result.amount.discount).toFixed(2)}</p>
                                <p><b>Next payment:</b> ${result.invoice_date}</p>
                                <p><b>New Plan price:</b> $${(result.amount.value).toFixed(2)}</p>

                              `,
                              confirmButtonText: "Open Invoice",
                              cancelButtonText: "Close",
                              showCancelButton: true,
                
                              customClass: { 
                                confirmButton: "btn btn-primary",
                                cancelButton: "btn btn-secondary ml-1",
                        
                               },
                
                            }).then((data) => {
                              const url = new URL(window.location.href);                              
  
                              if (data.isConfirmed == true) {                              
  
                                url.pathname = '/apps/invoice/preview/' + result.invoice_id;
                                url.href = url.origin + url.pathname;
                                url.searchParams.set('type', 'invoice');
  
                              }else{
                                url.searchParams.set('active', '10');
                              }
                              // Reload the page with the updated URL
                              window.location.href = url.toString();                              
                            })
                            
                            this.loadingButton = false;
                            break;
    
                          case "failed":
                            Swal.fire({
                              title: "Error",
                              text: result.message,
                              html:
                                '<div><p>'+ result.message +'<p/></div>',
                              icon: "error",
                              customClass: {
                                confirmButton: "btn btn-secondary",
                              },
                            });
                            this.loadingButton = false;  
                            break;
    
                          default:
                            break;
                        }
                        
                                  
                      });
                      
                      
                    }else{
                      if(data.dismiss === Swal.DismissReason.cancel){
                        this.active = 8;
                      }
                      this.loadingButton = false;
                      
                    }
                  });
             
            
            
              };
            });
    
          }else{
            Swal.fire({
              title: "Error",
              text: "You don't have an active payment method. Please, add one and try again.",
              icon: "error",
              confirmButtonText: "Add Payment Method",
              customClass: { 
                confirmButton: "btn btn-primary"      
               }
  
            }).then((data) => {
              if (data.isConfirmed == true) {     
                
                // Add a query parameter 'newParam=value' to the current URL
                const url = new URL(window.location.href);
                url.searchParams.set('active', '8');
  
                // Reload the page with the updated URL
                window.location.href = url.toString();
  
              };
            });
          };
        });
      }else{
        Swal.fire({
          title: "PROCEED TO REQUEST",
          html: `
              <p>By downgrading you will lose any amount paid for the current plan.</p>
              <p><b>Would you like to continue you request?</b></p>`,

          confirmButtonText: "Continue",
          cancelButtonText: "Cancel",
          showCancelButton: true,

          customClass: { 
            confirmButton: "btn btn-primary",
            cancelButton: "btn btn-secondary ml-1",
           },

          }).then((data) => {                
            if (data.isConfirmed == true) {
              this._customersService
              .changeSubscription(selected.id, this.paymentPeriod)
              .then((result: any) => {
                
                switch (result.status) {
                  case "succeeded":
                    this.getSubscriptionList();
                    Swal.fire({
                      icon: 'success',
                      title: 'Subscription changed',
                      html: `
                        <p>${result.message}</p>
                        <p><b>Invoice:</b>                          
                          ${result.invoice_id}
                        </p>
                        <p><b>Paid now:</b> $${(result.amount.value - result.amount.discount).toFixed(2)}</p>
                        <p><b>Next payment:</b> ${result.invoice_date}</p>
                        <p><b>New Plan price:</b> $${(result.amount.value).toFixed(2)}</p>

                      `,
                      confirmButtonText: "Open Invoice",
                      cancelButtonText: "Close",
                      showCancelButton: true,
        
                      customClass: { 
                        confirmButton: "btn btn-primary",
                        cancelButton: "btn btn-secondary ml-1",
                
                       },
        
                    }).then((data) => {
                      const url = new URL(window.location.href);                      

                      if (data.isConfirmed == true) {                              

                        url.pathname = '/apps/invoice/preview/' + result.invoice_id;
                        url.href = url.origin + url.pathname;
                        url.searchParams.set('type', 'invoice');

                      }else{
                        url.searchParams.set('active', '10');
                      }
                      // Reload the page with the updated URL
                      window.location.href = url.toString();                              
                    })
                    
                    this.loadingButton = false;
                    break;

                  case "failed":
                    Swal.fire({
                      title: "Error",
                      text: result.message,
                      html:
                        '<div><p>'+ result.message +'<p/></div>',
                      icon: "error",
                      customClass: {
                        confirmButton: "btn btn-secondary",
                      },
                    });
                    this.loadingButton = false;  
                    break;

                  default:
                    break;
                }
                
                          
              });
              
              
            }else{
              if(data.dismiss === Swal.DismissReason.cancel){
                this.active = 8;
              }
              this.loadingButton = false;
              
            }
          });
      }
    };  

  }

  openProductSide(index) {
    this.selectProduct(index);
    this._coreSidebarService.getSidebarRegistry("product-sidebar").toggleOpen();
  }

  openTemplateSide(index) {    
    this.selectTemplate(index);
  }

  /**
   * onClick getMyUser
   *
   */
  getMyUser() {
    var currentUser = JSON.parse(localStorage.getItem("currentUser"));
    this.loading = true;
    this.alertClose = true;
    this._userService
      .getById(currentUser.id)
      .pipe(first())
      .subscribe(
        (data) => {
          this.myUser = data;
          this.loading = false;
        },
        (error) => {
          this.loading = false;
        }
      );
  }

  changeUserRole(userIndex) {
    if (this.usersList[userIndex].id == this.myUser.id) {
      this._toastrService.error("You can not change you role.", "Error!.", {
        toastClass: "toast ngx-toastr",
        positionClass: 'toast-top-right',
        closeButton: true,
      });
    } else {
      var currentRole = this.usersList[userIndex].role;
      var role = "";
      if (currentRole == "Admin") {
        role = "User";
      } else {
        role = "Admin";
      }
      this._userService.changeRole(this.usersList[userIndex].id, role).then(
        (data) => {
          this.currentUser = data;

          // Change successful
          // Display confimation toast!
          this._toastrService.success(
            this.currentUser.firstName +
              " have successfully updated your profile. 🎉",
            "Success! Your profile was updated.",
            { toastClass: "toast ngx-toastr", 
              positionClass: 'toast-top-right',
              closeButton: true }
          );

          this.loadingButton = false;
        },
        (error) => {
          this.loadingButton = false;
        }
      );
    }
  }

  /**
   * onClick getCustomer
   *
   */
  getCustomer() {
    // loading
    var currentUser = JSON.parse(localStorage.getItem("currentUser"));

    this.loading = true;
    this._customersService
      .getById()
      .pipe(first())
      .subscribe(
        (data) => {
          this.customer = data;
          this.loading = false;
          
        },
        (error) => {
          this.loading = false;
        }
      );
  }

  /**
   * onClick getCustomer
   *
   */
  getLocations() {
    // loading
    this.loading = true;

    this._customersService.getLocations().subscribe(
      (data) => {
        this.locations = data;
        this.activeLocations = data;
        this.loading = false;

        //activeLocations is used to display locations available in the process of setting up a new user
        var tempLocation = this.activeLocations;
        this.activeLocations = [];
        tempLocation.forEach((element) => {
          if (element.locationStatus == "active") {
            this.activeLocations.push(element);
          }
        });
      },
      (error) => {
        this.loading = false;
      }
    );
  }

  createInviteLink(locationId: string) {
    Swal.fire({
      title: "Create invitation link?",
      text: "Name of Campaign:",
      input: "text",
      inputPlaceholder: "Enter campaign name",
      confirmButtonText: "Create",
      showCancelButton: true,
      customClass: {
        confirmButton: "btn btn-primary",
        cancelButton: "btn btn-danger ml-1",
      },
      preConfirm: (inputValue) => {
        if (!inputValue) {
          Swal.showValidationMessage("Campaign name is required!");
        }
        return inputValue;
      }
    }).then((result) => {
      if (result.isConfirmed && typeof result.value === "string") {
        const name = result.value; // ✅ result.value is now safely a string
  
        const input = document.getElementById("linkName" + locationId) as HTMLInputElement;
        if (input) input.value = name;
  
        const btn = document.getElementById("sendCreateLink" + locationId) as HTMLButtonElement;
        btn?.click();
      }
    });
  }

  sendCreateLink(locationId) {
    var input = <HTMLInputElement>(
      document.getElementById("linkName" + locationId)
    );
    var newLink = { location_id: locationId, name: input.value };

    this._customersService.createLocationLink(newLink).then(
      (data) => {
        var link = window.location.href.split("/pages");

        const url =
          link[0] + "/pages/authentication/register-v1?token=" + data["token"];

        Swal.fire({
          title: "All done!",
          html:
            'New Link: <a href="' +
            url +
            '"; (click)="copyLink(link)"> ' +
            url +
            "</a>",

          confirmButtonText: "OK",
          customClass: { confirmButton: "btn btn-primary" },
        });
        var navBtn = <HTMLInputElement>document.getElementById("ngb-nav-3");
        navBtn.click();
      },
      (error) => {
        this.loading = false;
      }
    );
  }

  sendDeleteLink(token) {
    this._customersService.deleteLocationLink(token).then(
      (data) => {
        Swal.fire({
          title: "Link Deleted",
          icon: "success",

          confirmButtonText: "OK",
          customClass: { confirmButton: "btn btn-primary" },
        }).then(function (result) {
          var navBtn = <HTMLInputElement>document.getElementById("ngb-nav-3");
          navBtn.click();
        });
      },
      (error) => {
        this.loading = false;
      }
    );
  }

  copyLink(inviteLink) {
    var link = window.location.href.split("/pages");
    const url =
      link[0] + "/pages/authentication/register-v1?token=" + inviteLink.token;
    Swal.fire({
      icon: "success",
      title: "Invitation Link",
      html: '<a href="' + url + '"; (click)="copyLink(link)"> ' + url + "</a>",

      confirmButtonText: "Copy",
      cancelButtonText: "Delete",

      showClass: { popup: "animate__animated animate__flipInX" },
      showCancelButton: true,
      customClass: {
        confirmButton: "btn btn-primary",
        cancelButton: "btn btn-danger ml-1",
      },
    }).then((data) => {
      if (data.isConfirmed == true) {
        navigator.clipboard.writeText(url);
      } else {
        var reason = String(data.dismiss);
        switch (reason) {
          case "cancel":
            this.sendDeleteLink(inviteLink.token);
            break;

          default:
            break;
        }
      }
    });
  }

  activateCoupon(coupon){
    Swal.fire({
      icon: "question",
      title: "Publish this coupon?",
      html: '<div><p>Once you publish this coupon, it can no longer be edited. Would you like to publish it now?</p></div>',
      allowOutsideClick: function () {
        return !Swal.isLoading();
      },
      showConfirmButton: true,
      confirmButtonText: 'Publish',
      showCancelButton: true,
      cancelButtonText: "Cancel"  
    }).then((result) => {

      if (result.value) {

        coupon.status = 'active';
        this._promoCodeService
        .updatePromoCode(coupon)
        .then(
          data => {
            // Change successful
            // Display confimation toast!
            this._toastrService.success(
              coupon.name +' have successfully updated. 🎉',
                'Success! Your coupon was updated.',
              { toastClass: 'toast ngx-toastr', closeButton: true }
            );
  
            this.loadingButton = false;
  
          },
          error => {
            Swal.fire({
              title: "Error",
              text: "This Coupon are not eligible.",
              html:
                '<div><p>'+ error +'<p/></div><div class="row">',
              icon: "error",
              customClass: {
                confirmButton: "btn btn-success",
              },
            });
            this.loadingButton = false;
          }
        );


      };
      this.loadingButton = false;

    });
    
    
  }

  activateLocation(id) {
    this.loading = true;
    var link = window.location.href.split("?");
    var return_link = { return_link: link[0] + "?active=4" };
    this._customersService.activateLocation(id, return_link).then(
      (data) => {
        if (data["url"] == null) {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: data["description"],
            showConfirmButton: true,
            allowOutsideClick: function () {
              return !Swal.isLoading();
            },
          });
        } else {
          window.open(data["url"], "_self");
        }
      },
      (error) => {
        this.loading = false;
      }
    );
  }

  handleCheckoutRedirect() {
    const currentPath = window.location.pathname;
    const link = window.location.href.split("?");
    if(link[1] === 'active=4&checkout=complete') {
      Swal.fire({
        icon: 'success',
        title: 'Payment Successful',
        text: 'Location successfully activated!',
        showConfirmButton: true,
      });
    } else if (link[1] === 'active=4&checkout=cancel') {
      Swal.fire({
        icon: 'error',
        title: 'Activation Pending',
        text: 'The payment process was not completed.',
        showConfirmButton: true,
      });
    }
  }

  inactivateLocation(id) {
    Swal.fire({
      html: "<h4> Do you want to delete this location? </h4>",

      confirmButtonText: "Yes",
      cancelButtonText: "No",

      showClass: { popup: "animate__animated animate__flipInX" },
      showCancelButton: true,
      customClass: {
        confirmButton: "btn btn-primary",
        cancelButton: "btn btn-secondary ml-1",
      },
    }).then((data) => {
      if (data.isConfirmed == true) {
        this.loading = true;

        this._customersService.inactivateLocation(id).then(
          (data) => {
            this.locations = data;
            this.loading = false;
          },
          (error) => {
            this.loading = false;
          }
        );
      }
    });
  }

  /**
   * Filter Item
   *
   */
  filterItemType(object, element1, element2, value) {
    var result = [];
    object.forEach((itens) => {
      itens[element1].forEach((item) => {
        if (item[element2] == value) {
          result.push(itens);
        }
      });
    });
    return result;
  }

  /**
   * Set the Avatar Status
   *
   */
  setAvatar(status) {
    switch (status) {
      case "pending":
        return "avatar-status-busy";

      case "active":
        return "avatar-status-online";

      case "inactive":
        return "avatar-status-offline";
    }
  }

  /**
   * onClick getUsersList
   *
   */
  getUsersList() {
    // loading
    var currentUser = JSON.parse(localStorage.getItem("currentUser"));

    this.loading = true;
    this._customersService
      .getUsersList()
      .pipe(first())
      .subscribe(
        (data) => {
          this.usersList = data;
          this.loading = false;          
        },
        (error) => {
          this.loading = false;
        }
      );
  }

  cleanSelectedGroup() {
    this.selectedGroup = { id: null, name: null };
  }

  getPlans(){
    this.loading = true;
    var dataplans = [];
    this.plans = {
      'groups':[],
      'plans': dataplans
    };
    
    this._productService.getGroups(dataplans);
    this._productService.getPlans2().then(result => {
      this.plans.plans = result;      
      this.loading = false;
    });
    return this.plans;
  }

  getTemplates(){
    this.loading = true;
    this._templateService.getAlltemplates('instalment').then(result => {
      this.templates = result;      
      this.loading = false;
    });    

    return this.templates;
  }

  getTemplatesModelList() {
    this._templateService
    .getTemplatesModels()
    .then((res) => {
      this.templatesModelList = res['instalment'];
      this.membershipModelList = res['membership']
    })
    .catch((error) => {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: error,
        showConfirmButton: true,
      });
    });
  }

  getTemplateId(id){
    this.loading = true;
    this._templateService.getTemplateEdit(id).then(result => {
      this.currentTemplate = result;      
      this.loading = false;
      this._coreSidebarService.getSidebarRegistry("template-sidebar").toggleOpen();
    });
  }

  changeTemplateStatus(id){
    const index = this.templates.findIndex(object => {
      return object.id === id;
    });   

    switch (this.templates[index].status) {
      case 'active':
        this.templates[index].status = 'inactive';
        break;
    
      default:
        this.templates[index].status = 'active';
        break;
    }

    
    this._templateService.updateTemplate({"id": this.templates[index].id,"status": this.templates[index].status}).then(result => {
    });

  };

  switchOpenModel(){
    this.isModelOpened = !this.isModelOpened;
  }


  /**
   * onClick getProductsList
   *
   */
  getProductsList() {
    this.loading = true;
    this.selectedGroup = { id: null, name: null };
    this.setNewProduct();
    this.products = this.getPlans();        
  }

  getCouponList(){
    this._promoCodeService
    .getAllPromoCodes()
    .then((couponList: any) => {
      this.promoCodes = couponList;
    });
  }

  getSubscriptionList(){
    this._customersService
    .getSubscriptionList()
    .then((subscriptionList: any) => {
      this.subscriptions = subscriptionList;
      this.paymentPeriod = this.subscriptions[1].planCycle;
    });
  }



  
  onLoadingChange(isLoading: boolean) {
    this.loading = isLoading;
  }


  setNewProduct() {
    this.currentProduct = {
      location_id: [],
      title: "",
      description: "",
      setupFee: 0,
      startDate: this.today,
      endDate: null,
      servicesProductsDiscounts: [
        {
          id: 0,
          name: "Diagnostic Services",
          offer: false,
          score: 0,
          discount: 0,
          terms: "",
        },
        {
          id: 1,
          name: "Preventive, Prophylactic and Bleaching Services",
          offer: false,
          score: 0,
          discount: 0,
          terms: "",
        },
        {
          id: 2,
          name: "Periodontics",
          offer: false,
          score: 0,
          discount: 0,
          terms: "",
        },
        {
          id: 3,
          name: "Oral Surgery",
          offer: false,
          score: 0,
          discount: 0,
          terms: "",
        },
        {
          id: 4,
          name: "Endodontics",
          offer: false,
          score: 0,
          discount: 0,
          terms: "",
        },
        {
          id: 5,
          name: "Restorative Services",
          offer: false,
          score: 0,
          discount: 0,
          terms: "",
        },
        {
          id: 6,
          name: "Prosthodontics",
          offer: false,
          score: 0,
          discount: 0,
          terms: "",
        },
        {
          id: 7,
          name: "Orthodontics",
          offer: false,
          score: 0,
          discount: 0,
          terms: "",
        },
        {
          id: 8,
          name: "General Services",
          offer: false,
          score: 0,
          discount: 0,
          terms: "",
        },
        {
          id: 9,
          name: "Miscellaneous",
          offer: false,
          score: 0,
          discount: 0,
          terms: "",
        },
      ],
      currency: "AUD",
      minPeriod: 12,
      ageFrom: 8,
      ageTo: 65,
      image: "https://i.imgur.com/JvWDeib.jpg",
      pricing: {
        annually: 0,
        monthly: 0,
        weekly: 0,
        fortnightly: 0,
      },
      treatment: [
        {
          title: "Dental Exams",
          annualQuantity: 2,
          score: 100,
          waitingPeriod: 6,
          specificTermsConditions: "No terms",
          procedures: [["011", "012"]],
        },
      ],
      generalTerms: [
        {
          title: "General",
          content: "",
        },
      ],
    };
  }

  setNewTemplate() {
    this.currentTemplate = 
    {
      "id": null,
      "created_at": null,
      "location_id": [],
      "title": "",
      "description": "",
      "settings": {
        "limits": {
          "amount": {
            "max": 100000,
            "min": 10
          },
          "monthsLimit": 60,
          "onlyMembers": false
        },
        "editable": {
          "amount": true,
          "deposit": true,
          "adminFee": true,
          "setupFee": true,
          "start_at": true,
          "instalmentTimes": true
        },
        "frequency": {
          "weekly": true,
          "fortnightly": true,
          "monthly": true,
        } 
      },
      "content": {
        "amount": null,
        "deposit": null,
        "adminFee": null,
        "setupFee": null,
        "start_at": null,
        "depositCash": true,
        "adminFeeCash": true,
        "setupFeeCash": true,
        "instalmentTimes": null,
        "paymentFrequency": "monthly"
      },
      "status": "active"
    };
    this._coreSidebarService.getSidebarRegistry("template-sidebar").toggleOpen();

  }

  /**
   * Select User
   */
  selectUser(index) {
    if (index != null) {
      
      this.currentUser = JSON.parse(JSON.stringify(this.usersList[index]));
      var userLocations = [];

      for (let index = 0; index < this.currentUser.location.length; index++) {
        const element = this.currentUser.location[index];
        userLocations.push(element.id);
      }
      this.currentUser["userLocations"] = userLocations;
    } else {
      this.currentUser = {
        firstName: "",
        lastName: "",
        email: "",
        phoneNumber: "",
        role: "",
        avatar: {
          id: "0",
          url: "assets/images/profile/user-uploads/user-00.png",
        },
        avatarFile: null,
        location: [],
      };
    }
  }
    /**
   * Select Coupon
   */
    selectCoupon(index) {
      if (index != null) {
        this.currentCoupon = JSON.parse(JSON.stringify(this.promoCodes[index]));  
      } else {
        this.currentCoupon =     
        {
          "name": "",
          "code": "",
          "startDate": this.today,
          "endDate": null,
          "status": null,
          "plan_id": [],
          "settings": {
              "setup_amount": 0,
              "setup_percentage": 0,
              "membership_amount": 0,
              "membership_percentage": 0
          },
          "report": {
              "visualization_counter": 0,
              "activation_counter": 0
          }
        };
      };
    };

  /**
   * Select Location
   */
  selectLocation(index) {    
    if (index != null) {
      this.currentLocation = JSON.parse(JSON.stringify(this.locations[index]));
    } else {
      this.currentLocation = {
        id: null,
        userId: [],
        locationName: "",
        locationAddress: "",
        locationZipCode: "",
        locationPhone: "",
        locationLogo: "",
        locationEmail: "",
        locationWebsite: "",
        locationDocId: "",
        locationDocType: "ABN",
        locationTimeZone: "",
        locationCurrency: "AUD",
        locationStatus: "inactive",
        settings: {
          "member_referral": {
              "isActive": false,
              "creditAmount": 0,
              "membership_amount": 0,
              "membership_percentage": 0,
              "setup_amount": 0,
              "setup_percentage": 0
          },
          "dependent_discount": {
              "isActive": false,
              "goal": 0,
              "membership_amount": 0,
              "membership_percentage": 0,
              "setup_amount": 0,
              "setup_percentage": 0
          }
      }
      };
    }
  }
  /**
   * Select User
   */
  selectProduct(id) {
    if (id != null) {
      const index = this.products.plans.findIndex((object) => {
        return object.id === id;
      });
      this.currentProduct = JSON.parse(JSON.stringify(this.products.plans[index]));
      
    } else {
      this.setNewProduct();
    }
    var categoryList = this.currentProduct.servicesProductsDiscounts.map(
      (object) => object.name
    );

    this.rows.category.forEach((element) => {
      element["offer"] = categoryList.indexOf(element.name) > -1;
      element["discounts"] = [];

      if (element["offer"]) {
        element["discounts"] =
          this.currentProduct.servicesProductsDiscounts[
            categoryList.indexOf(element.name)
          ].value;
      }
    });
  }

    /**
   * Select User
   */
    selectTemplate(index) {    
      if (index != null) {
        this.getTemplateId(this.templates[index].id)
      } else {
        this.setNewTemplate();
      }

    }
  

  sumValue(list, key) {
    var sum = 0;
    list.forEach((element) => {
      sum += element[key];
    });
    return sum;
  }

  filterStatus(list: any[]): any[] {
    return list.filter((p) => p.status == "active" || p.status == "suspended" || p.status == "paused");
  }

  selectModal(item, modalName){    
    this.selectedModal = item;
    this.modalService.open(modalName, {
      centered: true,
      size: 'lg'
    });  

  }

  useTemplate(type, id){
    this.loadingButton = true;

    this._templateService.useTemplate(type, id).then(result => {
      this.loadingButton = false;
      this.modalService.dismissAll();
      this.getTemplates();
      this.getProductsList();
    })
    .catch((error) => {
      this.loadingButton = false;
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: error,
        showConfirmButton: true,
      });
    });
  }

  // Lifecycle Hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */
  ngOnInit() {

    this.getCustomer();
    this._customersService
    .getStatement()
    
    .then((response: any) => {
    this.statement = response;
   
  })
  .catch((error) => {
    console.error('Failed to fetch payment methods:', error);
  });


    
      
    

    this.handleCheckoutRedirect();

    var currentUser = JSON.parse(localStorage.getItem("currentUser"));
    // get return url from route parameters or default to '1'
    this.active =
      Number(this._route.snapshot.queryParams["active"]) || Number("1");

    this.myUser = currentUser;
    this.getLocations();
    this.getUsersList();

    this.locations = [];
    this.customer = {
      logo: { url: "" },
    };
    this.getProductsList();
    this.getTemplates();
    this.getTemplatesModelList();


    // this.getCustomer();
    this._productService.getCodes().then((result) => {
      this.rows = result;
    });

    this._sharedLocationService
      .getLocationChangeEmitter()
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((locationId: number) => {
        this.getLocations();
        this.getProductsList();
        this.getTemplates();
        this.getTemplatesModelList();
        this.getCouponList();
        this.getSubscriptionList()
        this._productService.getCodes().then((result) => {
          this.rows = result;
        });
      });

    this.getCouponList();
    this.getSubscriptionList();
    
    // content header
    this.contentHeader = {
      headerTitle: "Account Settings",
      actionButton: true,
      breadcrumb: {
        type: "",
        links: [
          {
            name: "Home",
            isLink: true,
            link: "/",
          },
          {
            name: "Account Settings",
            isLink: false,
          },
        ],
      },
    };
  }

  /**
   * On destroy
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
  }

  changeUserStatus(user_id, status) {
    this._userService.changeStatus(user_id, status).then(
      (data) => {
        // Change successful
        // Display confimation toast!
        this._toastrService.success(
          this.currentUser.firstName +
            " have successfully updated your profile. 🎉",
          "Success! Your profile was updated.",
          { toastClass: "toast ngx-toastr", 
            positionClass: 'toast-top-right',
            closeButton: true }
        );

        this.getUsersList();
        this.loadingButton = false;
      },
      (error) => {
        this.loadingButton = false;
      }
    );
  };

  switchDiscountSettings(type) {
    var dependentOption = <HTMLInputElement>(
      document.getElementById("dependent_discount3")
    );

    var dollarOption = <HTMLInputElement>(
      document.getElementById("member_referral3")
    );

    switch (type) {
      case "dependent":
        this.currentLocation.settings.dependent_discount.isActive = !this.currentLocation.settings.dependent_discount.isActive;
        break;

      case "referral":
        this.currentLocation.settings.member_referral.isActive = !this.currentLocation.settings.member_referral.isActive;

      default:
        break;
    };
  };

  saveDiscountSetup(){
    this.loadingButton = true;
    

    return new Promise((resolve, reject) => {
      this._httpClient.patch(`${environment.apiUrl}/location/${this.currentLocation.id}`, this.currentLocation).subscribe(response => {
        this.loadingButton = false;

       // Add a query parameter 'newParam=value' to the current URL
      const url = new URL(window.location.href);
      url.searchParams.set('active', '7');

      // Reload the page with the updated URL
      window.location.href = url.toString();

        this._toastrService.success(
          this.currentLocation.locationName +
            " have successfully updated your discounts settings. 🎉",
          "Success! Your location was updated.",
          { toastClass: "toast ngx-toastr", 
            positionClass: 'toast-top-right',
            closeButton: true }
        );
  
        resolve(response);  
      }, reject);
    })
    .catch((error) => {
      this.loadingButton = false;
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: error,
        showConfirmButton: true,
        allowOutsideClick: function () {
          return !Swal.isLoading();
          
        }
      });
    });
  }

  /**
   * Submit
   *
   * @param form
   */
  submit(form, formName) {
    if (form.valid) {
      this.loadingButton = true;

      switch (formName) {
        case "updateMyUserForm":
          if (!this.myUser["avatarFile"]) {
            this.myUser["avatarFile"] = null;
          }
          this.alertClose = true;

          var newPassword = <HTMLInputElement>(
            document.getElementById("account-new-password")
          );
          var retypeNewPassword = <HTMLInputElement>(
            document.getElementById("account-retype-new-password")
          );

          // Change Password
          if (newPassword.value == retypeNewPassword.value) {
            if (newPassword.value != "") {
              this._userService
                .newPassword(newPassword.value, retypeNewPassword.value)
                .then(
                  (data) => {
                    // Change successful
                    // Display confimation toast!
                    this._toastrService.info(
                      "New password saved!",
                      "Success!",
                      { toastClass: "toast ngx-toastr",
                        positionClass: 'toast-top-right',
                        closeButton: true }
                    );
                  },
                  (error) => {}
                );
            }
            this._userService
              .updateMyProfile(
                this.myUser["id"],
                this.myUser["firstName"],
                this.myUser["lastName"],
                this.myUser["email"],
                this.myUser["phoneNumber"],
                this.myUser["avatarFile"]
              )
              .then(
                (data) => {
                  this.currentUser = data;

                  // Change successful
                  // Display confimation toast!
                  this._toastrService.success(
                    this.currentUser.firstName +
                      " have successfully updated your profile. 🎉",
                    "Success! Your profile was updated.",
                    { toastClass: "toast ngx-toastr", 
                      positionClass: 'toast-top-right',
                      closeButton: true }
                  );

                  this.loadingButton = false;
                },
                (error) => {
                  this.loadingButton = false;
                }
              );
          } else {
            setTimeout(() => {
              this.loadingButton = false;
              this.alertClose = false;
            }, 1000);
          }

          break;

        case "updateCompanyForm":
          var currentUser = JSON.parse(localStorage.getItem("currentUser"));

          this.loadingButton = true;
          this._customersService.updateById(this.customer).then(
            (data) => {
              // Change successful
              // Display confimation toast!
              this._toastrService.success(
                currentUser.firstName +
                  " have successfully updated " +
                  this.customer.customerName +
                  " informations. 🎉",
                "Success! Your company was updated.",
                { toastClass: "toast ngx-toastr", 
                  positionClass: 'toast-top-right',
                  closeButton: true }
              );
              this.customer = data;
              this.loadingButton = false;
            },
            (error) => {
              this.loadingButton = false;
            }
          );

        default:
          break;
      }
    }
  }

  /*************************************************************************************************
 * Import Patient List CSV
 ***************************************************************************************************/

  // Method to download the CSV
  downloadCSV() {
    var csvData: string = `firstName,lastName,documentNumber,nationality,countryAreaCode,phoneNumber,email,address,gender,dob
Matthew,Chambers,12345678,Australia,61,404000000,model@email.com,"123, Model St, City, Post Code",Female,31/01/1969
Sarah,Johnson,87654321,Australia,61,412345678,sarah.j@email.com,"456, George St, Sydney, NSW 2000",Female,15/07/1985
Daniel,Smith,23456789,Australia,61,423456789,daniel.s@email.com,"789, Collins St, Melbourne, VIC 3000",Male,22/03/1990
Emily,Brown,34567890,Australia,61,434567890,emily.b@email.com,"101, Adelaide St, Brisbane, QLD 4000",Female,05/12/1978`;
    const blob = new Blob([csvData], { type: 'text/csv' });
    const url = URL.createObjectURL(blob);
    
    // Create a temporary link element
    const link = document.createElement('a');
    link.href = url;
    link.download = 'Template Patient List.csv'; // The name of the file

    // Programmatically click the link to trigger the download
    link.click();

    // Clean up the object URL
    URL.revokeObjectURL(url);
  }

  uploadFile() {
    if (!this.selectedFile) {
      alert("Please select a file first!");
      return;
    }

    const formData = new FormData();
    formData.append('patients', this.selectedFile);  // Ensure this matches Xano's expected field name

    this.isUploading = true;

    this._httpClient.post(`${environment.apiUrl}/member/import`, formData, {
      reportProgress: true,
      observe: 'events'
    }).subscribe({
      next: (event: any) => {
        if (event.type === 1 && event.total) {
          this.uploadProgress = Math.round((event.loaded / event.total) * 100);
        } else if (event.type === 4) {
          this.isUploading = false;
          Swal.fire({
                        title: "Success!",
                        text: "File sent successfully.",
                        icon: "success",
                        customClass: {
                          confirmButton: "btn btn-success",
                        },
                      }).then(()=> {
                        this.clearUploaderQueue();

                      });
        }
      },
      error: (error) => {
        console.error('Upload failed:', error);
        this.isUploading = false;
        Swal.fire({
          icon: "error",
          title: "Upload Failed",
          text: error,
          showConfirmButton: true,
          allowOutsideClick: function () {
            return !Swal.isLoading();
          },
        });
      }
    });
  }

  // Prevent default behavior for dragover
  onDragOver(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
  }

  // Trigger file input when clicking the drop zone
  triggerFileInput(): void {
    this.fileInput.nativeElement.value = ''; // Clear previous selection
    this.fileInput.nativeElement.click();
    
  }

  onFileSelected(event: any): void {
    if (event.target.files.length > 0) {
      this.handleFile(event.target.files[0]);
      this.selectedFile = event.target.files[0];    
    }
  }

  async convertCsvToJson(csvData: string): Promise<any[]> {    
    return new Promise((resolve, reject) => {
      Papa.parse(csvData, {
        header: true, // Use the first row as keys
        skipEmptyLines: true, // Ignore empty lines
        complete: (result) => resolve(result.data),
        error: (error) => reject(error),
      });
    });
  }

  // Function to clear queue and add file
  async handleFile(file: File): Promise<void> {
    const fileType = file.name.split(".").pop()?.toLowerCase();

    if (fileType === "csv") {
      try {
        // Convert CSV to JSON
        const csvData = await this.readFileAsText(file);
        this.jsonData = await this.convertCsvToJson(csvData);
      } catch (error) {
        console.error("Error parsing CSV:", error);
        Swal.fire({
          icon: "error",
          title: "CSV Parsing Error",
          text: "Failed to process the CSV file.",
          showConfirmButton: true,
          allowOutsideClick: () => !Swal.isLoading(),
        });
        return;
      }
    } else {
      console.error("Unsupported file type:", fileType);
      Swal.fire({
        icon: "error",
        title: "Invalid File Type",
        text: "Please upload a CSV file.",
        showConfirmButton: true,
        allowOutsideClick: () => !Swal.isLoading(),
      });
      return;
    }

    // Add file to the uploader queue
    if (!this.uploader) {
      console.error("Uploader is not initialized");
      return;
    }

    // Reset the file input to allow re-uploading the same file
    const fileInput = document.getElementById("fileInput") as HTMLInputElement;
    if (fileInput) {
      fileInput.value = "";
    }

    this.selectedFile = file;

    // Trigger UI update
    this._cdr.detectChanges();
  }
  clearUploaderQueue(): void {
    // Reset the file input value to allow re-selection of the same file
    if (this.fileInput) {
      this.selectedFile = null;
      this.uploadProgress = 0;
      this.fileInput.nativeElement.value = "";
      this.jsonData = [];
    }

    // Force change detection to ensure Angular updates the view
    this._cdr.detectChanges();
  }

  // Helper method to read a file as text
  readFileAsText(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (e: any) => resolve(e.target.result);
      reader.onerror = (error) => reject(error);
      reader.readAsText(file);
    });
  }

  // Handle file drop
  onFileDrop(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();

    const files = event.dataTransfer?.files;
    if (files && files.length > 0) {
      this.handleFile(files[0]);
    }
  }

}
